import jwt_decode from 'jwt-decode'
export default {
    name: "Home",
    data() {
        return {
            companyForm: {
                id: '',
                // 中文名称
                companyName: '',
                // 公司英文全称
                companyNameEn: '',
                // 会员类型
                wiffaMembertype: '',
                // 注册城市
                registryCity: '',
                // 公司注册地
                registerAddress: '',
                // 公司网站
                site: '',
                // 微信公众号
                wechatOfficalAccounts: '',
                // 公司电话
                companyTel: '',
                // 公司年营业额
                annualSalesVolume: '',
                // 年运输箱量
                annualTransportVolume: '',
                // 公司人数
                companyNos: '',
                // 公司成立日期
                companyTime: '',
                // 国际区号
                interNatCode: '',
                // 货代舱平台管理员姓名
                adminName: '',
                // 管理员手机
                adminMobile: '',
                // 管理员微信
                adminWeixin: '',
                // 服务特色
                serviceFeatures: '',
                // 业务需求
                businessRequire: '',
                // 公司法人姓名
                corporationName: '',
                // 总经理姓名
                generalManager: '',
                // 总经理电话
                generalManagerMobile: '',
                // 总经理邮箱
                generalManagerEmail: '',
                // 业务助理姓名
                assistantName: '',
                // 业务助理电话
                assistantMobile: '',
                // 业务助理邮箱
                assistantEmail: '',
                // 签章集合
                seals: [],
                adminAccount: null,
                // 社会统一信用代码
                socialCreditCode: null
            },
            isPreview: false,
            previewTitle : this.$t('p_sealManage.seal_preview'),
            isSendService : '',
            isCollectService : '',
            sealImage: '',
            isAdmin: false,
        }
    },
    mounted: function () {
    },
    computed: {
        rules() {
            const checkPhone = (rule, value, callback) => {
                let phoneReg = /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/;
                if (value === "" || value == null) {
                    callback();
                } else if (!phoneReg.test(value)) {
                    callback(new Error(this.$t('companyManage.message.errPhone')));
                } else {
                    callback();
                }
            };
            const checkMail = (rule, value, callback) => {
                let mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
                if (value === "" || value == null) {
                    callback();
                } else if (!mailReg.test(value)) {
                    callback(new Error(this.$t('companyManage.message.errMail')));
                } else {
                    callback();
                }
            };
            return {
                companyName: [
                    {required: true, message: this.$t('companyManage.message.company_cName'), trigger: 'blur'},
                    {max: 100, message: this.$t('companyManage.message.tooLong') + 100, trigger: 'blur'}
                ],
                companyNameEn: [
                    {required: true, message: this.$t('companyManage.message.company_eName'), trigger: 'blur'},
                    {max: 100, message: this.$t('companyManage.message.tooLong') + 100, trigger: 'blur'}
                ],
                companyTel: [
                    {required: false, validator: checkPhone, trigger: 'blur'},
                ],
                adminMobile: [
                    {required: false, validator: checkPhone, trigger: 'blur'},
                ],
                generalManagerMobile: [
                    {required: false, validator: checkPhone, trigger: 'blur'},
                ],
                assistantMobile:[
                    {required: false, validator: checkPhone, trigger: 'blur'},
                ],
                generalManagerEmail:[
                    {required: false, validator: checkMail, trigger: 'blur'},
                ],
                assistantEmail:[
                    {required: false, validator: checkMail, trigger: 'blur'},
                ]

            }
        },
    },
    created() {
        this.getCompanyInfo();
        this.companyForm.adminAccount = jwt_decode(sessionStorage.getItem('token')).userAccount;
    },
    methods: {
        updateCompany(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, param, this.companyForm);
                    if(param.wiffaMembertype === '' || param.wiffaMembertype === undefined  || param.wiffaMembertype === null){
                        console.log(param.wiffaMembertype)
                        param.wiffaMembertype = -1;
                    }
                    // 重置审核结果
                    param.platformAuditDay = -1;
                    param.platformAuditOpinion = -1;
                    param.platformAuditResult = -1;
                    param.platformAuditUserAccount = -1;
                    param.platformAuditUserName = -1;
                   
                    this.$axios.put('/api/customerinfo/updatecustomerinfo', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.$message({
                                message: this.$t(response.data.message),
                                type: type,
                                duration: 10000,
                                center: true
                            });
                            // this.$router.push('/home');
                        } else {
                            this.$message({
                                message: this.$t(response.data.message),
                                type: type,
                                center: true
                            });
                        }
                        this.getCompanyInfo();
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
        // 签章预览
        preview(item) {
            this.isPreview = true;
            this.sealImage = "/api" + item.dealFile;
        },
        // 印章确认
        confirm(item) {
            const param = {};
            param.id = item.id;
            param.version = item.version;
            param.sealType = item.sealType;
            param.confirmStatus = 1;
            this.$axios.put('/api/seal/confirmstatus', param).then(response => {
                let type = 'error';
                if (response.data.status === '1') {
                    type = 'success';
                    this.getCompanyInfo();
                }
                this.$message({
                    message: this.$t(response.data.message),
                    type: type,
                    center: true
                });
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            })
        },
        // 印章启用禁用
        updateIsEnable(item) {
            const param = {};
            if (item.isenable === 1) {
                param.isenable = 0;
            } else {
                param.isenable = 1;
            }
            param.id = item.id;
            param.version = item.version;
            param.sealType = item.sealType;
            param.copanyId = item.copanyid;
            if (item.confirmStatus !== 1) {
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'warning',
                    center: true
                });
            }
            this.$axios.put('/api/seal/updatedisable', param).then(response => {
                let type = 'error';
                if (response.data.status === '1') {
                    type = 'success';
                    this.getCompanyInfo();
                }
                this.$message({
                    message: this.$t(response.data.message),
                    type: type,
                    center: true
                });
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            })
        },
        confirmCancelUpdate() {
            this.$confirm(this.$t('companyManage.confirmCancelUpdate'), {
              confirmButtonText: this.$t('companyManage.determine'),
              cancelButtonText: this.$t('companyManage.cancel'),
              type: 'warning',
                center: true
            }).then(() => {
                this.$router.push('/home');
            }).catch(() => {
            });
        },
        getCompanyInfo() {
            this.$axios.get('/api/customerinfo/selectcustomerbyparam').then(response => {
                this.companyForm = response.data.resultData[0];
                if (this.companyForm.isSend !== 2) {
                    this.isSendService = 'info';
                }
                if (this.companyForm.isReceive !== 2) {
                    this.isCollectService = 'info';
                }
                const token = jwt_decode(sessionStorage.getItem('token'));
                if(!this.companyForm.adminAccount === token.userAccount){
                    this.isAdmin = true;
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        back() {
            this.$router.back();
        }
    }
}
